export const colors = {
  primary: '#0284c7',
  secondary: '#69C847',
};

export default colors;
